

































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import SalesOrderService from '@/services/SalesOrderService';
import { SalesOrderDTO } from '@/dto/sales/orders/SalesOrderDTO';
import RouteNames from '@/router/RouteNames';
import { processError } from '@/utils/ComponentUtils';
import moment from 'moment';

@Component
export default class SalesOrderDetails extends Vue {
  @Prop({ required: true }) id!: string | number;

  private order: SalesOrderDTO | null = null;
  private loading = false;
  private RouteNames = RouteNames;

  async mounted() {
    await this.loadOrder();
  }

  async loadOrder() {
    this.loading = true;
    try {
      const response = await SalesOrderService.getOrderById(Number(this.id));
      this.order = response.data;
    } catch (e) {
      processError(e, this);
    } finally {
      this.loading = false;
    }
  }

  get hasSubscriberPrices(): boolean {
    return !!this.order?.items.some(item => item.subscriberPriceCents !== null);
  }

  get statusClass(): string {
    if (!this.order) return '';
    switch (this.order.status) {
      case 'COMPLETED':
      case 'PAID':
        return 'bg-success text-white';
      case 'PENDING':
      case 'CREATED':
      case 'PLACED':
        return 'bg-warning text-dark';
      case 'CANCELLED':
      case 'REJECTED':
        return 'bg-danger text-white';
      default:
        return 'bg-secondary text-white';
    }
  }

  formatCurrency(cents: number): string {
    if (!this.order) return '';
    const symbol = this.order.currency === 'USD' ? '$' : this.order.currency + ' ';
    return `${symbol}${(cents / 100).toFixed(2)}`;
  }

  formatDate(dateStr: string | null): string {
    if (!dateStr) return '—';
    return moment(dateStr).format('MMM DD, YYYY HH:mm');
  }
}
